import React from "react";
import CustomButton from "../../shared/CustomButton";
import { formatNumber, ShoppingCart02 } from "../../normalizer";

const AddProductToCar = (props) => {
  const { item, actions, currencyLabel } = props;
  const { is_favorite } = item;
  const heartClass = [
    "cursor-pointer text-3xl",
    !is_favorite && "far fa-heart primary-text",
    is_favorite && "fa fa-heart fav primary-text",
  ].join(" ");
  return (
    <div className="product-detail__add-to-cart">
      <div className="product-detail__add-to-cart__points">
        <div className="product-detail__add-to-cart__points-container">
          <span className="product-detail__add-to-cart__points-value">
            {formatNumber(item.points)}
          </span>
          <div className="product-detail__add-to-cart__points-currency">
            {currencyLabel}
          </div>
        </div>
      </div>
      <div className="product-detail__add-to-cart__actions">
        <CustomButton onClick={() => actions.onCartAdd(item)}>
          <ShoppingCart02 />
          Adicionar ao carrinho
        </CustomButton>
        <i
          className={heartClass}
          onClick={() =>
            item.is_favorite
              ? actions.onFavRemove(item)
              : actions.onFavAddition(item)
          }
        />
      </div>
    </div>
  );
};

const ProductDetail = ({ main_image, description }) => {
  return (
    <div className="product-detail-body">
      <div
        className="product-detail-body__content"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

const Item = ({ item, currencyLabel, ...actions }) => {
  return (
    <div className="product-detail__container">
      <div className="product-detail__image-container">
        <img
          className="product-detail__image"
          src={item.product.main_image.url}
          alt={item.product.name}
        />
      </div>
      <div className="product-detail__content">
        <div className="product-detail__header">
          <h4 className="product-detail__title">{item.product.name}</h4>
          <AddProductToCar
            item={item}
            currencyLabel={currencyLabel}
            {...actions}
          />
        </div>
        <div className="product-detail__content">
          <ProductDetail {...item.product} />
        </div>
      </div>
    </div>
  );
};

export default Item;
